import $ from 'jquery';
import _ from 'underscore';
import SlideshowPagination from 'app/cms/carpricechecker/views/result/SlideshowPagination.html';
import ComparableCars from 'app/cms/carpricechecker/views/result/ComparableCars.html';
import ToggleButton from 'app/cms/carpricechecker/views/result/ToggleButton.html';
import Slideshow from 'picnic/slideshow/views/Slideshow';


var
	slideshowPaginationTemplate = _.template(SlideshowPagination),
	numberComparableCarsTemplate = _.template(ComparableCars),
	toggleButtonTemplate = _.template(ToggleButton),
	SELECTOR_SLIDESHOW = '.slideshow:first'
;


class View extends Slideshow {

	constructor(options) {
		var
			settings = {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				responsive: [
					{
						breakpoint: 1230,
						settings: {
							slidesToScroll: 3,
							slidesToShow: 3
						}
					},
					{
						breakpoint: 900,
						settings: {
							slidesToScroll: 2,
							slidesToShow: 2
						}
					}
				],
				arrows: false,
				adaptiveHeight: true,
				accessibility: false
			}
		;

		super($.extend(true, {
			selector: SELECTOR_SLIDESHOW,
			settings: settings
		}, options));
	}

	render() {
		super.render();

		var self = this;

		_.bindAll(
			self,
			'_renderComparableCarsPagination',
			'_renderNumberPagination',
			'_onAfterChange',
			'_onExtrasClick',
			'_scrollToForm',
			'_toggleAria'
		);

		$.each(self.$el.find('.extras'), function() {
			self._content = $(toggleButtonTemplate({
				number: $(this).find('> ul li').length,
				dropdownid: $(this).find('ul').attr('id')
			})).prependTo(this).on('click', self._onExtrasClick);
		});

		self._renderNumberPagination();
		self._renderComparableCarsPagination();
		self.$el.find('.filter-result a').on('click', self._scrollToForm);
		self.slideshow.$slider.on('afterChange', self._onAfterChange);

		return self;
	}

	get currentSlide() {
		return ((this.slideshow.currentSlide ? this.slideshow.currentSlide : 0) + this.slideshow.options.slidesToShow) / this.slideshow.options.slidesToScroll;
	}

	get steps() {
		return this.$el.find('.pagination li').length;
	}

	get totalSlides() {
		return this.slideshow.slideCount;
	}

	_scrollToForm() {
		this.context.dispatch('scrollToCarpricechecker:cpc-warning');
	}

	_toggleAria($target, value) {
		$target.find('> ul').attr('aria-hidden', !value);
		$target.find('> ul').attr('aria-expanded', value);
	}

	_renderNumberPagination() {
		var $el = this.$el.find('.results');

		$(slideshowPaginationTemplate({
			steps: this.steps,
			currentSlide: this.currentSlide,
		})).appendTo($el);

		this._slideshowPagination = this.$el.find('.slideshow-pagination-wrapper');
		this._slideshowPagination
			.on('click', '.next', () => this.slideshow.next())
			.on('click', '.prev', () => this.slideshow.prev());
	}

	_renderComparableCarsPagination() {
		this._numberComparableCars = $(numberComparableCarsTemplate({
			totalSlides: this.totalSlides
		})).prependTo(this.$el.find('.cpc-slideshow'));
	}

	_onAfterChange() {
		// close the extra section
		this.$el.find('.extras.is-open').removeClass('is-open');

		// Update the pagination number
		this._slideshowPagination.find('span:first').text(
			this.currentSlide + ' / ' + this.steps
		);
	}

	_onExtrasClick(event) {
		event.preventDefault();

		var
			IS_OPEN_CLASSNAME = 'is-open',
			$eventWrapper = $(event.target).parent()
		;

		$eventWrapper.toggleClass(IS_OPEN_CLASSNAME, !$eventWrapper.hasClass(IS_OPEN_CLASSNAME));

		this._toggleAria($eventWrapper, $eventWrapper.hasClass(IS_OPEN_CLASSNAME));
	}

}

export default View;
